import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TipoMoneda } from '../../shared/models/system';
import { environment } from '../../../environments/environment.dev';
import { Auth } from './auth.service';

@Injectable({ providedIn: 'root' })
export class TipoMonedaService {
  private apiUrl = `${environment.apiUrl}/tipo-moneda`;

  constructor(private http: HttpClient, private auth: Auth) {}

  private getHeaders() {
    const token = this.auth.getToken();
    return {
      headers: new HttpHeaders({ 'Authorization': `Bearer ${token}` })
    };
  }

  getAll(): Observable<TipoMoneda[]> {
    return this.http.get<TipoMoneda[]>(`${this.apiUrl}`, this.getHeaders());
  }

  getActive(): Observable<TipoMoneda[]> {
    return this.http.get<TipoMoneda[]>(`${this.apiUrl}/active`, this.getHeaders());
  }

  create(tipoMoneda: Partial<TipoMoneda>): Observable<TipoMoneda> {
    return this.http.post<TipoMoneda>(`${this.apiUrl}`, tipoMoneda, this.getHeaders());
  }

  update(id: number, tipoMoneda: TipoMoneda): Observable<TipoMoneda> {
    return this.http.put<TipoMoneda>(`${this.apiUrl}/${id}`, tipoMoneda, this.getHeaders());
  }

  toggle(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, this.getHeaders());
  }
}
